<ng-container *ngIf="(notifications$ | async) as notifications">
    <button data-test="B-Notification-Button" mat-button
            class="user-button"
            (click)="notificationsOpen = !notificationsOpen">
        <ng-container *ngIf="notificationsUnread$ | async as notificationsUnread">
            <mat-icon class="s-24 secondary-text"
                      [color]="notificationsUnread.length ? 'accent' : undefined"
                      [matBadge]="notificationsUnread.length"
                      [matBadgeHidden]="!notificationsUnread.length"
                      matBadgeColor="accent">
                <ng-container *ngIf="notificationsUnread.length > 0; else noNotifications">
                    notifications_active
                </ng-container>
                <ng-template #noNotifications>
                    notifications
                </ng-template>
            </mat-icon>
        </ng-container>
    </button>

    <ng-container *ngIf="notificationsOpen">
        <!-- todo: finish notifications integration -->
        <div class="notification-overlay">

            <header class="notification-header">
                {{ 'layout.notifications.title' | translate }}

                <button mat-icon-button (click)="notificationsOpen = false">
                    <mat-icon>close</mat-icon>
                </button>
            </header>

            <mat-tab-group dynamicHeight="true">

                <mat-tab [label]="'layout.notifications.tabUnread' | translate">
                    <div class="p-12">
                        <ng-container *ngFor="let notification of notifications">
                            <p>
                                <span [innerHTML]="notification.message"></span>
                            </p>
                        </ng-container>
                    </div>
                </mat-tab>

                <mat-tab [label]="'layout.notifications.tabRead' | translate">
                    <div class="p-12">
                        <ng-container *ngIf="notificationsUnread$ | async as notificationsUnread">
                            <ng-container *ngFor="let notification of notificationsUnread">
                                <p>
                                    <span [innerHTML]="notification.message"></span>
                                </p>
                            </ng-container>
                        </ng-container>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>
    </ng-container>
</ng-container>
